exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "  .linkout-1 {\n    fill: grey;\n  }\n", ""]);
